var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLife(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11918_80467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H56C58.2091 0 60 1.79086 60 4V56C60 58.2091 58.2091 60 56 60H4C1.79086 60 0 58.2091 0 56V4Z",
    fill: "#00CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2595 67.0661C29.2595 67.0661 55.6145 60.8222 60.0579 42.8035L65.9824 18.7786L44.0708 7.00372L19.197 7.24134L13.2725 31.2663C8.82906 49.285 29.2595 67.0661 29.2595 67.0661Z",
    fill: "#006A72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6693 63.9221C24.6693 63.9221 50.9931 57.8047 55.3897 39.9757L61.2519 16.2036L39.3247 4.492L14.4665 4.6664L8.60431 28.4385C4.2077 46.2675 24.6693 63.9221 24.6693 63.9221Z",
    fill: "#0097A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6693 63.9221C24.6693 63.9221 50.9931 57.8047 55.3897 39.9756L61.2519 16.2036L39.3247 4.49195L24.6693 63.9221Z",
    fill: "#037A83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.601 23.8377C46.5453 21.9449 44.8116 20.6002 42.7815 20.0996C40.7513 19.5989 38.5912 19.9834 36.7765 21.1684L34.912 22.3853L33.827 20.441C31.6279 16.5004 26.7816 15.3053 23.0025 17.7717C19.2234 20.2381 17.9426 25.4321 20.1417 29.3727L21.2267 31.317L29.1904 45.5874L42.8756 36.6556L44.7402 35.4387C46.5553 34.2546 47.8766 32.367 48.4131 30.1912C48.9497 28.0154 48.6575 25.7299 47.601 23.8377Z",
    fill: "#00CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6009 23.8375C46.5453 21.9448 44.8115 20.6001 42.7814 20.0995C40.7513 19.5988 38.5912 19.9833 36.7765 21.1683L34.9119 22.3852L29.1903 45.5873L42.8756 36.6555L44.7401 35.4386C46.5553 34.2545 47.8766 32.3668 48.4131 30.1911C48.9496 28.0153 48.6575 25.7298 47.6009 23.8375Z",
    fill: "#02B7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11918_80467"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H56C58.2091 0 60 1.79086 60 4V56C60 58.2091 58.2091 60 56 60H4C1.79086 60 0 58.2091 0 56V4Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLife);
export default __webpack_public_path__ + "static/media/life.944588910b84f10fd6d1ad0ec064ccd7.svg";
export { ForwardRef as ReactComponent };